import './index.scss';
import Loader from 'react-loaders';
import AnimatedLetters from '../AnimatedLetters'
import {useState, useEffect} from 'react'
import predictedVotes from '../../assets/images/predictNumberOfUpvotes.jpg'
import forecastDemand from '../../assets/images/forecastDemand.png'
import emergencyVehicle from '../../assets/images/emergencyVehicle.jpg'
import predictFlight from '../../assets/images/predictFlight.png'
import predictEcommerce from '../../assets/images/predictEcommerce.jpg'
import machineHack from '../../assets/images/machineHack.png'
import analyticsVidhya from '../../assets/images/analyticsVidhya.png'


const Accolades = () =>{
    const [letterClass, setLetterClass] = useState('text-animate');

    useEffect(() => {
        setTimeout(() => {
          return setLetterClass('text-animate-hover')
        }, 2500)
      }, [])

    return (
        <div>
            <div className = 'container skills-page' > 
                <div className = 'text-zone' style = {{'width':'85%'}}> 
                    
                    <h1> 
                        <AnimatedLetters 
                            letterClass={letterClass}
                            strArray={['Hackathons']}
                            idx = {15} 
                        />
                    </h1>

                    <div className = 'overall-text'> 

                        <div className = 'machine-hack'>
                            
                        <a href = 'https://machinehack.com/user/profile/5ef0a238b7efcc325e392338'>
                            <h2>                                     
                                <img src={machineHack} alt='machine-hack-user'/>

                                MACHINEHACK
                            </h2>
                        </a>

                            <p>
                                <table>
                                    <tr>
    
                                        <th>

                                        </th>
                                        <th> 
                                            Hackathon
                                        </th>
                                        <th> 
                                            Rank
                                        </th>
                                        <th> 
                                            Total
                                        </th>
                                    </tr>
                                
                                    <tr>
                                    
                                        <td>
                                            <img src = {predictFlight} alt = {'flight-tix'}/>
                                            </td>
                                        <td> 
                                            Predict the flight price
                                        </td>
                                        <td> 
                                            85
                                        </td>
                                        <td> 
                                            3300
                                        </td>
                                    </tr>
                                    
                                    <tr>
                                        <td>
                                            <img src = {predictEcommerce} alt = {'demand-ecommerce'}/>
                                            </td>
                                        <td> 
                                            Predict the price of commodities on an e-commerce platform
                                        </td>
                                        <td> 
                                            19
                                        </td>
                                        <td> 
                                            600
                                        </td>
                                    </tr>

                                </table>
                            </p>
                            

                        </div>

                        <div className = 'analytics-vidhya'>
                            <a href = 'https://www.analyticsvidhya.com/user/rohan7797'>
                                <h2>                                     
                                    <img src={analyticsVidhya} alt='analytics-vidhya-user'/>

                                    ANALYTICS VIDHYA
                                </h2>
                            </a>

                            <p>
                                <table>
                                    <tr>
    
                                        <th>

                                        </th>
                                        <th> 
                                            Hackathon
                                        </th>
                                        <th> 
                                            Rank
                                        </th>
                                        <th> 
                                            Total
                                        </th>
                                    </tr>
                                
                                    <tr>
                                    
                                        <td>
                                            <img src = {predictedVotes} alt = {'upvotes'}/>
                                            </td>
                                        <td> 
                                            Predict the upvote of a question
                                        </td>
                                        <td> 
                                            70
                                        </td>
                                        <td> 
                                            904
                                        </td>
                                    </tr>
                                    
                                    <tr>
                                        <td>
                                            <img src = {forecastDemand} alt = {'demand-forecast'}/>
                                            </td>
                                        <td> 
                                            Forecast the demand of fulfilment centers
                                        </td>
                                        <td> 
                                            249
                                        </td>
                                        <td> 
                                            3500
                                        </td>
                                    </tr>
                                    
                                    <tr>
                                        <td>
                                            <img src = {emergencyVehicle} alt = {'emergency-vehicle'}/>
                                            </td>
                                        <td> 
                                            Identify emergency vehicles from non-emergency vehicles
                                        </td>
                                        <td> 
                                            15
                                        </td>
                                        <td> 
                                            15000
                                        </td>
                                    </tr>
                                </table>
                            </p>
                        </div>

                    </div>
                </div>
            </div>

            <Loader type='pacman'/>
        </div>
    )
};

export default Accolades;